import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  inject,
  Input,
  QueryList,
} from '@angular/core';

@Component({
  selector: 'sigecom-content-container',
  template: `
    <div
      class="min-h-full flex flex-col"
      [ngClass]="{ 'px-12': hasPadding }"
      [style.padding-top.rem]="topGap"
      [style.padding-bottom.rem]="bottomGap"
    >
      <ng-container *ngIf="title || titleDetais || hasButtonsContent">
        <div class="flex justify-between">
          <div class="flex items-baseline gap-3 mb-4">
            <h2 *ngIf="title" class="text-sigecom-gray text-2xl font-semibold">
              {{ title }}
            </h2>
            <h3
              *ngIf="titleDetais"
              class="text-sigecom-info text-lg font-medium"
            >
              {{ titleDetais }}
            </h3>
          </div>
          <div>
            <ng-content select="[buttons]"></ng-content>
          </div>
        </div>
      </ng-container>

      <ng-content select="[before-content]"></ng-content>

      <div
        class="flex gap-4"
        [class.flex-row]="contentDirection === 'row'"
        [class.flex-col]="contentDirection === 'column'"
      >
        <ng-content select="[content]"></ng-content>
      </div>

      <ng-content select="[after-content]"></ng-content>
    </div>
  `,
  styleUrls: ['./content-container.component.scss'],
})
export class ContentContainerComponent implements AfterContentInit {
  @Input() title?: string;
  @Input() titleDetais?: string;
  @Input() hasPadding: boolean = true;
  @Input() contentDirection: 'row' | 'column' = 'row';
  // O padrão do tailwind p-12 é 3rem.
  // Mantendo o padrão 3, as outras telas não quebram.
  @Input() topGap: number = 3;
  @Input() bottomGap: number = 3;
  @Input() horizontalGap: number = 3;

  hasButtonsContent = false;

  @ContentChildren('sigecom-button', { descendants: true })
  buttonsContent!: QueryList<unknown>;

  private readonly cdr = inject(ChangeDetectorRef);

  ngAfterContentInit(): void {
    this.buttonsContent.changes.subscribe(() => this.updateButtonsContent());
    this.updateButtonsContent();
  }

  private updateButtonsContent(): void {
    this.hasButtonsContent = this.buttonsContent.length > 0;
    this.cdr.detectChanges();
  }
}
